<template>
    <div class="container-fluid">
        <div class="container">
            <div class="d-flex justify-content-center">
                <div v-if="onboardStep=== 0">
                    <div class="text-center">
                        <small class="text-primary">Step 1/5</small>
                    </div>
                    <div class="text-center py-5">
                        <h4 class="onboarding-text">Welcome to Dukakit! We're excited 😊 to help you get started. </h4>
                        <p>We would like to ask you a few questions to setup your account</p>
                    </div>
                    <button @click="onboardUser" class="btn btn-primary btn-block">Let's get started <i class="bi bi-chevron-right"></i> </button>
                </div>
                <div v-if="onboardStep=== 1">
                    <div class="text-center">
                        <small class="text-primary">Step 2/5</small>
                    </div>
                    <div v-if="hasAffiliate">
                        <div class="text-center py-5">
                            <h3>Onboarding fee </h3>
                            <hr />
                            <p>From the look of things you were onboarded by our affiliate</p>
                            <p>You will be required to pay for onboarding fee to facilitate for stock taking and staff training.</p>
                            <p>Please select the appropriate package guided by our affiliate. <br/>Note this will affect your inventory later.</p>
                        </div>
                        <div class="form-group">
                            <select v-model="affiliateForm.onboardingPackages" class="form-control">
                            <option value="null" >Please Select package</option>
                            <option value="subscription" >Subscription only </option>
                            <option value="3000" >Kshs 3,000 Package</option>
                            <option value="5000" >Kshs 5,000 Package</option>
                            <option value="10000" >Kshs 10,000 Package</option>
                        </select>
                        </div>
                        <button @click="onboardUser" class="btn btn-primary btn-block">Continue <i class="bi bi-chevron-right"></i> </button>
                    </div>
                    <div v-else>
                        <div class="text-center py-5">
                            <h4 class="onboarding-text">How did you get to know about Dukakit?</h4>
                            <small>Please check where applicable</small>
                            <div class="py-2 text-left ml-5">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" value="" name="seo" v-model="onboardingQuizes.source">
                                    <label class="form-check-label" for="defaultCheck1">
                                          Online searches Google
                                        </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" value="mouth" name="source" v-model="onboardingQuizes.source">
                                    <label class="form-check-label" for="defaultCheck1">
                                            From friend
                                        </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" value="social" name="source" v-model="onboardingQuizes.source">
                                    <label class="form-check-label" for="defaultCheck1">
                                            From social media
                                        </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" value="other" name="source" v-model="onboardingQuizes.source">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Other
                                        </label>
                                </div>
                            </div>
                        </div>
                        <button @click="onboardUser" class="btn btn-primary btn-block">Continue <i class="bi bi-chevron-right"></i> </button>
                    </div>
                </div>
                <div v-if="onboardStep=== 2">
                    <div class="py-2">
                        <a class="btn btn-outline-dark" @click="onboardOneStepBack"> <i class="bi bi-chevron-left"></i> Back</a>
                    </div>
                    <div class="text-center">
                        <small class="text-primary">Step 3/5</small>
                    </div>
                    <div class="text-center py-5">
                        <h4 class="onboarding-text">Which payments do you accept?</h4>
                        <small>Please check where applicable</small>
                        <div class="py-2 text-left ml-5">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="Cash" name="paymentcash" v-model="onboardingQuizes.payments">
                                <label class="form-check-label" for="defaultCheck1">
                                            Cash
                                        </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="M-pesa" name="paymentmpesa" v-model="onboardingQuizes.payments">
                                <label class="form-check-label" for="defaultCheck1">
                                            M-pesa
                                        </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="Cards" name="paymentcards" v-model="onboardingQuizes.payments">
                                <label class="form-check-label" for="defaultCheck1">
                                            Cards
                                        </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="Buy Now Pay Later" name="paymentbnpl" v-model="onboardingQuizes.payments">
                                <label class="form-check-label" for="defaultCheck1">
                                            Buy Now Pay Later (BNPL) - <small>This is if you allow customers to take items on credit</small>
                                        </label>
                            </div>
                        </div>
                    </div>
                    <button @click="onboardUser" class="btn btn-primary btn-block">Continue <i class="bi bi-chevron-right"></i> </button>
                </div>
                <div v-if="onboardStep=== 3">
                    <div class="py-2">
                        <a class="btn btn-outline-dark" @click="onboardOneStepBack"> <i class="bi bi-chevron-left"></i> Back</a>
                    </div>
                    <div class="text-center">
                        <small class="text-primary">Step 3/5</small>
                    </div>
                    <div class="text-center py-5">
                        <h4 class="onboarding-text">Do you have employees?</h4>
                        <small>Please check where applicable</small>
                        <div class="py-2 text-left ml-5">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" value="only me" name="employees" v-model="onboardingQuizes.employees">
                                <label class="form-check-label" for="defaultCheck1">
                                           Only me
                                        </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" value="1-10" name="employees" v-model="onboardingQuizes.employees">
                                <label class="form-check-label" for="defaultCheck1">
                                            1-10 Employees
                                        </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" value="11-50" name="employees" v-model="onboardingQuizes.employees">
                                <label class="form-check-label" for="defaultCheck1">
                                            11-50 Employees
                                        </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" value="51-100" name="employees" v-model="onboardingQuizes.employees">
                                <label class="form-check-label" for="defaultCheck1">
                                          51-100 Employees
                                        </label>
                            </div>
                        </div>
                    </div>
                    <button @click="onboardUser" class="btn btn-primary btn-block">Continue <i class="bi bi-chevron-right"></i> </button>
                </div>
                <div v-if="onboardStep=== 4">
                    <div class="py-2">
                        <a class="btn btn-outline-dark" @click="onboardOneStepBack"> <i class="bi bi-chevron-left"></i> Back</a>
                    </div>
                    <div class="text-center">
                        <small class="text-primary">Step 4/5</small>
                    </div>
                    <div class="text-center py-5">
                        <h4 class="onboarding-text">Setup Taxes?</h4>
                        <p>Dukakit can help you create and manage taxes quickly and efficiently.
                            <br/>It is your responsibility to review and file your taxes on time. <br/>Consult your tax advisor to ensure taxes are applied and filed correctly. <br/>Taxes auto apply to your POS orders. </p>
                        <div class="py-2 text-left ml-5">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" value="1" name="vat-taxes" v-model="onboardingQuizes.vatTax">
                                <label class="form-check-label" for="defaultCheck1">
                                          All Prices are inclusive of VAT Tax
                                        </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" value="2" name="vat-taxes" v-model="onboardingQuizes.vatTax">
                                <label class="form-check-label" for="defaultCheck1">
                                            All Prices are exclusive of VAT Tax
                                        </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" value="0" name="vat-taxes" v-model="onboardingQuizes.vatTax">
                                <label class="form-check-label" for="defaultCheck1">
                                            I will setup taxes later
                                        </label>
                            </div>
                        </div>
                    </div>
                    <button @click="onboardUser" class="btn btn-primary btn-block">Continue <i class="bi bi-chevron-right"></i> </button>
                </div>
                <div v-if="onboardStep=== 5">
                    <div class="py-2">
                        <a class="btn btn-outline-dark" @click="onboardOneStepBack"> <i class="bi bi-chevron-left"></i> Back</a>
                    </div>
                    <div class="text-center">
                        <small class="text-primary">Step 4/5</small>
                    </div>
                    <div class="text-center py-2 " style="min-width: 400px !important;">
                        <h3>Watch our quick tour video</h3>
                        <hr />
                        <div style="position: relative; padding-bottom: 62.5%; height: 0;"><iframe src="https://www.loom.com/embed/016f87b9029e4ecabde5023b65567a5b?sid=ff770cf1-3456-4e7e-811a-1316faae2ec5" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>
                        <hr />
                        <button @click="onboardUser" class="btn btn-primary btn-block">Finish and Setup my account <i class="bi bi-chevron-right"></i> </button>
                    </div>
                </div>
                <div v-if="onboardStep=== 6">
                    <div class="py-2">
                        <!-- <a class="btn btn-outline-dark" @click="onboardOneStepBack"> <i class="bi bi-chevron-left"></i> Back</a> -->
                    </div>
                    <div class="card" style="max-width:40rem">
                        <div class="card-body">
                            <div class="text-center py-5">
                                <div class="loading"></div>
                                <div class="text-center" style="padding-left: 60px; padding-right: 60px;">
                                    <hr class="border-0" />
                                    <p class="pt-5">Please wait...</p>
                                    <p>{{ onboardResponseMessage }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal ref="installationFeeModal" hide-footer no-close-on-esc no-close-on-backdrop hide-header-close>
            <div class="text-center" v-if="!checkMpesaResponsePoll">
                <h5>Pay for installation fee via M-pesa</h5>
                <p>To continue please enter M-pesa phone number you will use to pay</p>
                <hr/>
                <h4 v-if="affiliateForm.onboardingPackages !=='null'">Amount to Pay: {{convertCurrencyToShillings(affiliateForm.onboardingPackages)}}</h4>
                <hr/>
                <form @submit.prevent="processOnbaordingFee">
                    <input class="d-none" type="hidden" v-model="affiliateForm.onboardingPackages">
                    <vue-tel-input placeholder="Enter Mpesa number" v-on:validate="validatePhoneNumber" v-model="affiliateForm.phoneNumber">
                    </vue-tel-input>
                    <div class="form-group my-2">
                        <button type="submit" class="btn btn-primary">Continue to pay</button>
                    </div>
                </form>
            </div>
            <div v-else class="text-center pt-3">
                <div v-html="statusHolder">
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'
    import {
        mapGetters
    } from 'vuex'
    export default {
        name: 'onboardcustomer',
        data() {
            return {
                onboardStep: 0,
                hasAffiliate: false,
                onboardingQuizes: {
                    employees: '',
                    manageShop: '',
                    vatTax: '',
                    source: '',
                    payments: [],
                    affiliatePayment: '',
                    onboardingPackages: ''
                },
                onboardResponseMessage: 'Confirming company details',
                affiliateForm: {
                    mpesaPhoneNumber: '',
                    phoneNumber: '',
                    onboardingPackages: null,
                    updateProgress: true
                },
                checkMpesaResponsePoll: null,
                statusHolder: '<div class="spinner-border text-primary" role="status">\n' +
                    '  <span class="sr-only">Loading...</span>\n' +
                    '</div>' +
                    '<h4 class="py-1">We have sent you a request!</h4><p>Please check your phone for M-Pesa pin input to confirm.... </p>',
            }
        },
        watch: {
            "affiliateForm.onboardingPackages": function(before, after) {
                if (this.affiliateForm.onboardingPackages !== 'subscription' && this.affiliateForm.onboardingPackages !== 'null') {
                    this.affiliateForm.onboardingPackages = parseFloat(this.affiliateForm.onboardingPackages)
                    this.$refs.installationFeeModal.show()
                }
                this.onboardingQuizes.onboardingPackages = this.affiliateForm.onboardingPackages
            }
        },
        computed: {
            ...mapGetters(['userDetails'])
        },
        mounted() {
            this.getCurrentOnboardStatus()
            this.checkAffiliation()
        },
        methods: {
            async onboardUser() {
                try {
                    this.processingMessage = "Setting up your account...";
                    this.isProcessing = true; // Optional: Add a loading spinner flag
                    const response = await axios.post('/api/onboard-user', { ...this.onboardingQuizes
                    });
                    const data = response.data;
                    if (response.status === 200) {
                        this.onboardStep = data.onboard_progress;

                        if (data.onboard_progress == 5) {
                            const messages = [{
                                    delay: 1000,
                                    text: "Adding payment gateway..."
                                },
                                {
                                    delay: 2000,
                                    text: "Finalizing your account setup..."
                                },
                                {
                                    delay: 2500,
                                    text: "Done. Redirecting you shortly..."
                                },
                            ];
                            for (let step of messages) {
                                await new Promise(resolve => setTimeout(resolve, step.delay));
                                this.onboardResponseMessage = step.text;
                            }
                            // Redirect after final step
                            setTimeout(() => {
                                this.isProcessing = false;
                                window.location.replace('/app');
                            }, 1000);
                        }
                    }

                } catch (error) {
                    console.error("Onboarding error:", error);
                    this.processingMessage = "There was an error setting up your account. Please reload the page and try again.";
                    this.isProcessing = false;
                }
            },
            onboardOneStepBack() {
                if (this.onboardStep > 0) {
                    this.updateStepProgress(parseInt(this.onboardStep - 1))
                }
            },
            async getCurrentOnboardStatus() {
                await axios.get('/api/current-onboarding-progress').then(results => {
                    if (results.status === 200) {
                        const steps = (results.data.onboard_progress !== null) ? results.data.onboard_progress : 0

                        if (results.data.has_paid_subscription && steps < 2) {
                            this.updateStepProgress(2)
                            this.onboardStep = 2
                        } else if (results.data.has_paid_subscription && steps > 2) {
                            this.onboardStep = steps
                        } else {
                            this.onboardStep = steps
                        }
                    }
                }).catch(error => {
                    console.log(error)
                })
            },
            async updateStepProgress(progress) {
                await axios.post('/api/current-onboarding-progress', {
                    progress: parseInt(progress)
                }).then(results => {
                    if (results.status === 200) {
                        this.onboardStep = (results.data.onboard_progress !== null) ? results.data.onboard_progress : 0
                    }
                }).catch(error => {
                })
            },
            async checkAffiliation() {
                await axios.get('api/company-affiliate-status').then(
                    results => {
                        this.hasAffiliate = results.data
                    }
                ).catch()
            },
            async processOnbaordingFee() {
                if (this.affiliateForm.mpesaPhoneNumber !== '') {
                    await axios.post('/api/pay-onboarding-fee', { ...this.affiliateForm
                    }).then(results => {
                        if (results.status === 200) {
                            this.updateStepProgress(0);
                            this.checkMpesaResponsePoll = setInterval(() => {
                                axios.get('/api/validate-mpesa-onboarding', {
                                    params: {
                                        bill_id: results.data.id
                                    }
                                }).then(checkerresults => {
                                    if (checkerresults.data.message === 1) {
                                        this.statusHolder = "<div class=\"success-checkmark\">\n" +
                                            "  <div class=\"check-icon\">\n" +
                                            "    <span class=\"icon-line line-tip\"></span>\n" +
                                            "    <span class=\"icon-line line-long\"></span>\n" +
                                            "    <div class=\"icon-circle\"></div>\n" +
                                            "    <div class=\"icon-fix\"></div>\n" +
                                            "  </div>\n" +
                                            "</div> <div class='text-center'> <h6 class='text-smanel-gray-lvl3'>Your payment has been received</h6> </div>"
                                        setInterval(() => {
                                            // clear polling ID
                                            clearInterval(this.checkMpesaResponsePoll);
                                            // CLOSE MODAL
                                            this.onboardingQuizes.affiliatePayment = results.data.id
                                            this.$refs['installationFeeModal'].hide();
                                        }, 3000)
                                        this.updateStepProgress(2)
                                    }
                                    if (checkerresults.data.message === 0) {
                                        this.statusHolder = "<div class=\"container text-center\">\n" +
                                            "<h5 class=\"text-danger text-smanel-50\">\n" +
                                            "<i class=\"bi bi-x-circle\"></i>\n" +
                                            "</h5>\n" +
                                            "<p>There was an issue with payment (" + checkerresults.data.description + ") </p>\n" +
                                            "\n" +
                                            "<a class=\"btn btn-success\" href=\"/app\">Retry Payment</a>\n" +
                                            "\n" +
                                            "</div>"
                                    }
                                }).catch()
                            }, 10000)
                        }
                    }).catch()
                }
            },
            validatePhoneNumber(phoneNumber) {
                if (phoneNumber.valid) {
                    this.affiliateForm.mpesaPhoneNumber = phoneNumber.number
                }
            },
        }
    }
</script>
